var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorePhoneNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h28v28H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71 18.99c-.22-.28-.53-.46-.88-.5l-2.36-.54c-.27-.06-.54-.05-.8.05-.26.11-.49.28-.68.49l-2.71 2.8a23.037 23.037 0 0 1-5.21-3.83 26.547 26.547 0 0 1-4.08-5.3l2.77-2.61c.21-.16.36-.39.43-.65.07-.29.08-.6.02-.9l-.66-2.8A1.42 1.42 0 0 0 8.13 4H5.36c-.37-.01-.72.13-.98.39-.25.26-.39.6-.38.96.04 2.28.63 4.52 1.72 6.52 1.15 2.22 2.65 4.24 4.42 6 1.77 1.77 3.81 3.26 6.03 4.41 2 1.09 4.23 1.68 6.5 1.72h.12c.71-.03 1.27-.64 1.23-1.35v-2.68c0-.35-.1-.7-.32-.98ZM5.32 8.05c-.26-.89-.38-1.81-.38-2.74v-.04c.01-.18.17-.31.35-.3h2.83c.12 0 .23.03.33.09s.16.17.17.28l.63 2.9c.02.11.02.22 0 .33-.01.1-.06.19-.13.27L6.47 11.3C6 10.25 5.61 9.16 5.31 8.05Zm17.76 14.68c0 .08-.03.16-.09.22-.07.06-.16.1-.25.09-.91-.02-1.81-.13-2.69-.33-.99-.2-1.95-.54-2.85-.99l2.55-2.67c.05-.06.12-.1.2-.13.09-.02.18-.02.27 0l2.46.5c.12 0 .24.06.32.16.07.09.1.2.09.32v2.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorePhoneNumber);
export default __webpack_public_path__ + "static/media/Store Phone Number.c024404bd74fc408f0724c3ab495a488.svg";
export { ForwardRef as ReactComponent };